import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const SECTIONS = [
  {
    title: "01 — Finding a business",
    items: [
      { q: "What is TradeFlow UK?", a: "TradeFlow UK is a directory of independent small businesses across the UK, from sole traders to small firms — builders, driving instructors, landscapers, electricians, gas engineers, cleaners, hairdressers and many more." },
      { q: "How do I find someone near me?", a: "Choose a service and type your town or postcode in the search bar. You'll see every listed business that matches." },
      { q: "How do I contact a business?", a: "Each listing shows the business's phone, email and website where provided. You can also send an enquiry from the listing page and it goes straight to their inbox." },
      { q: "Does it cost anything to use?", a: "No. Searching the directory and contacting businesses is free." },
    ],
  },
  {
    title: "02 — Listing your business",
    items: [
      { q: "Who can list?", a: "Any UK small business — sole traders, partnerships and limited companies — with an activation word. Create an account, fill in your listing and add photos of your work." },
      { q: "Is there a turnover limit?", a: "Yes. TradeFlow UK is for small businesses with a maximum annual turnover of £750,000." },
      { q: "When does my listing go live?", a: "Straight away. As soon as you publish it, your listing appears in the directory." },
      { q: "Can I edit my listing?", a: "Yes, from your dashboard. Changes go live immediately." },
      { q: "Where do enquiries go?", a: "Enquiries are emailed to the address on your listing and are also shown in your dashboard." },
    ],
  },
  {
    title: "03 — Good to know",
    items: [
      { q: "Do you vet the work of businesses?", a: "We check listings for accuracy and suitability, but we don't inspect work or guarantee any business. Always ask for references, insurance and qualifications (e.g. Gas Safe registration) before hiring." },
      { q: "How do I report a listing?", a: "Email support@tradeflowwork.com with the business name and the problem, and our team will look into it." },
    ],
  },
];

export default function FAQ() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="faq-page">
      <p className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-2">Help</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter mb-10">Frequently asked questions</h1>
      {SECTIONS.map((s, si) => (
        <section key={s.title} className="mb-10">
          <h2 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-3">{s.title}</h2>
          <Accordion type="single" collapsible className="border border-zinc-200 rounded-lg bg-white px-4">
            {s.items.map((it, i) => (
              <AccordionItem key={it.q} value={`${si}-${i}`} data-testid={`faq-item-${si}-${i}`}>
                <AccordionTrigger className="text-left font-display font-semibold">{it.q}</AccordionTrigger>
                <AccordionContent className="text-zinc-600 leading-relaxed">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      ))}
    </div>
  );
}
